import { render, staticRenderFns } from "./Pinjaman-Desktop.vue?vue&type=template&id=13a716c4"
import script from "./Pinjaman-Desktop.vue?vue&type=script&lang=js"
export * from "./Pinjaman-Desktop.vue?vue&type=script&lang=js"
import style0 from "./Pinjaman-Desktop.vue?vue&type=style&index=0&id=13a716c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports